/**
 * Based off of https://github.com/lindenlab/extraction-tools/blob/master/web/src/components/Money/useCurrencyFormatter.js
 */

import { useMemo } from "react";
import { useSettings } from "utils/settingsContext";
import { useLanguageContext } from "utils/LanguageProvider";
import { CurrencyDisplay } from "./types.js";
import createCurrencyFormatter from "./createCurrencyFormatter.js";

/**
 * Returns a formatter function which accepts a Tilia currency value (the value in the
 * lowest-common denomination of that currency, for example: cents for "USD") as a Number,
 * Number, or string, and returns a localized formatted string.
 *
 * @param {string} currency
 * @param {CurrencyDisplay} currencyDisplay
 * @returns {function(value: Number|string): string}
 */
function useCurrencyFormatter(currency, currencyDisplay = CurrencyDisplay.Symbol) {
  const { integratorSettings } = useSettings();
  const { locale } = useLanguageContext();

  return useMemo(() => {
    return createCurrencyFormatter(
      locale,
      currency,
      currencyDisplay,
      integratorSettings?.virtualCurrencies?.currencies || {}
    );
  }, [locale, currency, currencyDisplay, integratorSettings?.virtualCurrencies]);
}

export default useCurrencyFormatter;
